import { Button, Col, Form, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { PlusOutlined } from "@ant-design/icons"
import { useTaxes } from "Shared/hooks/tax.hooks"
import { getDefaultTaxId } from "Shared/utils/helper.utils"
import { LineItemsListProps } from "../types/LineItems.interfaces"
import { createDefaultLineItem } from "../types/utils/helper.util"
import { LineItemCard } from "./LineItemCard"

export const LineItemsList = ({ lineItems, expandedItems, onToggleExpand, onAdd, onChange, onRemove, currency, form }: LineItemsListProps) => {
    const { t } = useTranslation()
    const taxRates = useTaxes()

    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className="text-sm font-medium"> {t("purchaseOrders:drawer.lineItems")}</div>
                </Col>
            </Row>

            <Form.List
                name="lineItems"
                initialValue={
                    lineItems.length > 0
                        ? lineItems
                        : [
                              createDefaultLineItem({
                                  costCenter: form.getFieldValue("costCenter"),
                                  costCenter2: form.getFieldValue("costCenter2"),
                                  expenseAccount: form.getFieldValue("expenseAccount"),
                                  taxRate: { _id: form.getFieldValue("taxRate") ?? getDefaultTaxId(taxRates) },
                              }),
                          ]
                }
            >
                {(fields, { add }) => (
                    <>
                        <div className="line-item-card" style={{ width: "fit-content !important" }}>
                            {fields.map((field, idx) => (
                                <LineItemCard
                                    key={field.key}
                                    field={field}
                                    idx={idx}
                                    expanded={expandedItems[field.name]}
                                    onToggleExpand={() => onToggleExpand(field.name)}
                                    onRemove={(index) => {
                                        onRemove(index)
                                    }}
                                    onChange={onChange}
                                    canRemove={fields.length > 1}
                                    currency={currency}
                                />
                            ))}
                        </div>

                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                const newItem = createDefaultLineItem(lineItems[lineItems.length - 1])
                                add(newItem)
                                onAdd?.()
                            }}
                            className="font-normal text-[15px] leading-normal rounded-lg shadow-none flex items-center gap-2 p-[15px] mb-16 mt-8"
                            style={{ width: "fit-content" }}
                        >
                            {t("purchaseOrders:drawer.addItem")}
                        </Button>
                    </>
                )}
            </Form.List>
        </>
    )
}
